import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Anchor, Clock, Zap, Repeat, CheckCircle } from 'lucide-react';
export function MethodSection() {
  const steps = [{
    letter: 'A',
    title: 'Acción mínima',
    desc: '5 minutos (nunca cero). La meta no es intensidad, es presencia.',
    icon: <Clock className="w-6 h-6 text-[#d4af37]" data-id="element-108" />
  }, {
    letter: 'N',
    title: 'Nutriente espiritual',
    desc: 'Un ritual breve que conecta con Dios sin complicaciones.',
    icon: <Anchor className="w-6 h-6 text-[#d4af37]" data-id="element-109" />
  }, {
    letter: 'C',
    title: 'Cue (Señal)',
    desc: 'Algo físico y visible que dispara el hábito automáticamente.',
    icon: <Zap className="w-6 h-6 text-[#d4af37]" data-id="element-110" />
  }, {
    letter: 'L',
    title: 'Loop',
    desc: 'Repetición simple. Misma hora o mismo gatillo.',
    icon: <Repeat className="w-6 h-6 text-[#d4af37]" data-id="element-111" />
  }, {
    letter: 'A',
    title: 'Auditoría sin culpa',
    desc: 'Tracking para ver la verdad sin castigarte.',
    icon: <CheckCircle className="w-6 h-6 text-[#d4af37]" data-id="element-112" />
  }];
  return <section className="py-24 md:py-32 bg-[#0a1628] relative overflow-hidden" data-id="element-113">
      {/* Subtle background texture */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#d4af37 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-114"></div>

      <div className="max-w-5xl mx-auto px-6 relative z-10" data-id="element-115">
        <FadeIn data-id="element-116">
          <div className="text-center mb-20" data-id="element-117">
            <span className="text-[#d4af37] tracking-widest uppercase text-sm font-semibold mb-4 block" data-id="element-118">
              La Solución
            </span>
            <h2 className="text-4xl md:text-6xl text-white mb-6" data-id="element-119">
              Presento: el Método <span className="text-[#d4af37]" data-id="element-120">ANCLA</span>
            </h2>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-121">
              Esto es lo que cambia todo. En vez de pelear por ser
              "disciplinado", tú construyes un ANCLA.
            </p>
          </div>
        </FadeIn>

        <div className="grid gap-6" data-id="element-122">
          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-123">
              <div className="bg-[#1e3a5f]/20 border border-[#1e3a5f] hover:border-[#d4af37]/50 transition-colors p-6 md:p-8 rounded-lg flex items-start gap-6 group" data-id="element-124">
                <div className="flex-shrink-0 w-16 h-16 bg-[#0a1628] rounded-full flex items-center justify-center border-2 border-[#1e3a5f] group-hover:border-[#d4af37] transition-colors shadow-lg" data-id="element-125">
                  <span className="font-serif text-3xl font-bold text-white" data-id="element-126">
                    {step.letter}
                  </span>
                </div>
                <div data-id="element-127">
                  <div className="flex items-center gap-3 mb-2" data-id="element-128">
                    <h3 className="text-xl md:text-2xl font-bold text-white" data-id="element-129">
                      {step.title}
                    </h3>
                    <div className="hidden md:block opacity-0 group-hover:opacity-100 transition-opacity transform translate-x-[-10px] group-hover:translate-x-0 duration-300" data-id="element-130">
                      {step.icon}
                    </div>
                  </div>
                  <p className="text-gray-300 text-lg leading-relaxed" data-id="element-131">
                    {step.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} data-id="element-132">
          <div className="mt-16 text-center" data-id="element-133">
            <p className="text-2xl md:text-3xl font-serif italic text-[#f4e4c1]" data-id="element-134">
              "Este no es un método para 'hacer más'.
              <br data-id="element-135" />
              Es un método para{' '}
              <span className="text-[#d4af37] underline decoration-1 underline-offset-4" data-id="element-136">
                dejar de desaparecer
              </span>
              ."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}